import { ContactAddress, Gender } from "cy-api/simple-payments/common-models";
import { ReactNode } from "react";
import { z } from "zod";

// TODO: move steps and stepper section mapping into steps.ts file
export const Step = z.enum([
  "start",
  "accountType",
  "accountLimit",
  "personal",
  "marketing",
  "password",
  "otp",
  "done",
]);
export type Step = z.infer<typeof Step>;
export const stepFlow: Step[] = [
  "start",
  "accountType",
  "accountLimit",
  "personal",
  "marketing",
  "password",
  "otp",
  "done",
];

export interface Country {
  name: string;
  countryCode: string;
  countryCode3: string;
  disabled: boolean;
}

export interface PersonalInfoInputs {
  firstName: string;
  middleName: string;
  lastName: string;
  email?: string;
  sourceofFunds?: number | null;
  occupation?: number | null;
  nationality?: number | null;
  nationalId?: string;

  dateOfBirth: {
    day: number;
    month: number;
    year: number;
  };
  gender: Gender;
}

export interface AddressInputs {
  physicalAddress: ContactAddress;
  nationality?: number;
}

export interface AccountType<T extends string = string> {
  id: T;
  name: string;
  label?: string;
  description: string;
  icon?: ReactNode;
}

export interface AccountLimit<TLimit extends string = string> {
  id: TLimit;
  name: string;
  label: string;
  description: string;
  icon?: ReactNode;
}
